import React from 'react'
import CartItem from './CartItem'
import CartSummary from './CartSummary'

const CartDisplay = ({ currentCart, assistantInfo, isAutoJoining }) => {
    const renderEmptyState = () => {
        if (isAutoJoining) {
            return (
                <div className="text-center py-5">
                    <div className="text-muted" style={{ fontSize: '1.5rem', lineHeight: '1.6' }}>
                        <div className="spinner-border text-warning mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div>Connecting to POS system...</div>
                    </div>
                </div>
            )
        }

        return (
            <div className="text-center py-5">
                <div className="text-muted" style={{ fontSize: '1.5rem', lineHeight: '1.6' }}>
                    Waiting for order data...
                </div>
            </div>
        )
    }

    const renderCartItems = () => {
        if (!currentCart?.items || currentCart.items.length === 0) {
            return (
                <div className="text-center py-5">
                    <div className="text-muted" style={{ fontSize: '1.3rem' }}>
                        No items in cart
                    </div>
                </div>
            )
        }

        return (
            <div className="row g-3">
                {currentCart.items
                    .slice()
                    .reverse()
                    .map((item, idx) => (
                        <CartItem key={idx} item={item} index={idx} />
                    ))}
            </div>
        )
    }

    if (!currentCart) {
        return renderEmptyState()
    }

    return (
        <>
            {/* Scrollable items area */}
            <div className="mb-4" style={{ height: 480, overflowY: 'auto', overflowX: 'hidden' }}>
                {renderCartItems()}
            </div>

            {/* Cart summary */}
            <CartSummary assistantInfo={assistantInfo} totalAmount={currentCart.totalsAfter} />
        </>
    )
}

export default CartDisplay
